const GrowingUp = () => {
    return (
        <div className="aboutMeContent">
			<h1 className="heading1">Growing Up</h1>

            <p className="text">
                I had a very overwhelming childhood, having to move
                all over the world between the US, Ireland, and Indonesia.
            </p>

            <p className="text">
                I spent a lot of my time outside playing sports, so
                my younger self would have never expected to become
                interested in programming. 
            </p>

            <p className="text">
                Until high school, I never really had access to
                computers...
            </p>

			<div className="bottomText">

            </div>
		</div>
    )
}

export default GrowingUp;